import { AccountPanel, type AccountPanelCallbacks } from './account-panel';
import { getStoredSession } from '../account/session';
import { openModal } from './modal';

/** A small trigger button (email or "Log in") that opens the account/sync UI in a popup on click. */
export class AccountModal {
  private triggerEl: HTMLElement;
  private callbacks: AccountPanelCallbacks;

  constructor(container: HTMLElement, callbacks: AccountPanelCallbacks) {
    this.triggerEl = container;
    this.callbacks = callbacks;
    this.renderTrigger();
  }

  private renderTrigger() {
    this.triggerEl.innerHTML = '';
    const btn = document.createElement('button');
    btn.className = 'btn account-trigger-btn';
    const session = getStoredSession();
    btn.innerHTML = session
      ? `<span class="status-dot ok"></span><span class="account-trigger-label">${escapeHtml(session.email || 'Account')}</span>`
      : '<span class="status-dot off"></span><span class="account-trigger-label">Log in / Sign up</span>';
    btn.title = session ? 'Account and sync settings' : 'Sign in to sync your key, settings and conversations';
    btn.addEventListener('click', () => this.open());
    this.triggerEl.appendChild(btn);
  }

  /** Also used as the mobile Account tab's entry point, via main.ts. */
  open() {
    const modal = openModal('Account');
    new AccountPanel(modal.bodyEl, {
      ...this.callbacks,
      // Keeps the trigger's label (email vs "Log in") in sync as the panel signs in/out.
      onStateChanged: () => this.renderTrigger(),
    });
  }
}

function escapeHtml(value: string): string {
  return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
